/* eslint-disable jsx-a11y/alt-text */
import { ArrowLeftIcon } from "@heroicons/react/outline";
import { LoadingModal } from "Component/LoadingModal";
import { Notify } from "Component/Notify";
import { fetchApi } from "Config/fetchApi";
import React from "react";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { ROUTES } from "Route/ConstantRoute";
import {
  convertToISOString,
  displayBinaryImage,
  handleError,
  isoStringToDateInput,
} from "Helper";
import { decryptNik } from "Config/cripto";
import { fetchImageUrl } from "Config/fetchImage";
import { Skeleton } from "@mui/material";

function UpdateRegisterFace() {
  const navigate = useNavigate();
  const location = useLocation();
  const argumentData = location.state;
  const [uuid] = useState(argumentData?.uuid || "");
  const [isLoading, setIsLoading] = useState(false);
  const [nik, setNik] = useState(decryptNik(argumentData?.nik) || "");
  const [isActive, setIsActive] = useState(argumentData?.isActive);
  const [fullName, setFullName] = useState(argumentData?.fullName || "");
  const [placeOfBirth, setPlaceOfBirth] = useState(
    argumentData?.placeOfBirth || ""
  );
  const [dateOfBirth, setDateOfBirth] = useState(
    isoStringToDateInput(argumentData?.dateOfBirth) || ""
  );
  const [address, setAddress] = useState(argumentData?.address || "");
  const [occupation, setOccupation] = useState(argumentData?.occupation || "");
  const [genderId, setGenderId] = useState("");
  const [bloodTypeId, setBloodTypeId] = useState(
    argumentData?.bloodTypeId || ""
  );
  const [religionId, setReligionId] = useState(argumentData?.religionId || "");
  const [maritalTypeId, setMaritalTypeId] = useState(
    argumentData?.maritalTypeId || ""
  );
  const [nationalityId, setNationalityId] = useState(
    argumentData?.nationalityTypeId || ""
  );

  // ==================== State for select master data ==================== //
  const [dataGender, setDataGender] = useState([]);
  const [dataBloodType, setDataBloodType] = useState([]);
  const [dataReligion, setDataReligion] = useState([]);
  const [dataMaritalType, setDataMaritalType] = useState([]);
  const [dataNationality, setDataNationality] = useState([]);

  // ==================== Get data master ==================== //
  const getDataGender = async () => {
    try {
      setIsLoading(true);
      const response = await fetchApi().get(`/gender/get-list`);
      setDataGender(response.data?.data);
      getDataBloodType();
    } catch (err) {
      setDataGender([]);
      setIsLoading(false);
      handleError(err);
    }
  };

  const getDataBloodType = async () => {
    try {
      const response = await fetchApi().get(`/blood-type/get-list`);
      setDataBloodType(response.data?.data);
      getDataReligion();
    } catch (err) {
      setDataBloodType([]);
      setIsLoading(false);
      handleError(err);
    }
  };

  const getDataReligion = async () => {
    try {
      const response = await fetchApi().get(`religion-type/get-list`);
      setDataReligion(response.data?.data);
      getDataMaritalType();
    } catch (err) {
      setDataReligion([]);
      setIsLoading(false);
      handleError(err);
    }
  };

  const getDataMaritalType = async () => {
    try {
      const response = await fetchApi().get(`/marital-type/get-list`);
      setDataMaritalType(response.data?.data);
      getDataNationality();
    } catch (err) {
      setDataMaritalType([]);
      setIsLoading(false);
      handleError(err);
    }
  };

  const getDataNationality = async () => {
    try {
      const response = await fetchApi().get(`/nationality-type/get-list`);
      setDataNationality(response.data?.data);
      setIsLoading(false);
    } catch (err) {
      setDataNationality([]);
      setIsLoading(false);
      handleError(err);
    }
  };

  useEffect(() => {
    getDataGender();
  }, []);

  // ==================== Tambahan ==================== //
  useEffect(() => {
    if (argumentData?.genderName && dataGender.length > 0) {
      const matchedGender = dataGender.find(
        (item) => item.gender_name === argumentData.genderName
      );
      if (matchedGender) {
        setGenderId(matchedGender.id);
      }
    }
  }, [argumentData?.genderName, dataGender]);

  // ==================== File Upload ==================== //
  const [preview, setPreview] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  // ==================== Default ==================== //
  const goBack = () => {
    navigate(ROUTES.management_data.RegisterFace.register_face_home);
  };
  const handleSuccess = (message) => {
    Notify.success({
      title: "Berhasil",
      description: message,
    });
  };

  // ==================== Default ==================== //

  const updateData = async () => {
    try {
      setIsLoading(true);
      const reqBody = {
        nik,
        is_active: isActive,
        fullName,
        placeOfBirth,
        dateOfBirth: convertToISOString(dateOfBirth),
        address,
        occupation,
        genderId,
        bloodTypeId,
        religionId,
        maritalTypeId,
        nationalityId,
      };
      const response = await fetchApi().put(`/person/update/${uuid}`, reqBody);
      setIsLoading(false);
      handleSuccess(response.data?.message);
      goBack();
    } catch (err) {
      setIsLoading(false);
      handleError(err);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrorMessage("");
    updateData();
  };

  const [imageUrl, setImageUrl] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!argumentData?.image) return;

    const getImage = async () => {
      setLoading(true);
      setError(false);

      try {
        const objectURL = await fetchImageUrl({
          imagePath: argumentData.image,
        });
        setImageUrl(objectURL?.url);
      } catch (err) {
        handleError(err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    getImage();
  }, [argumentData?.image]);

  return (
    <div>
      <div className="text-lg font-bold text-start gap-2 pb-5">
        <p
          className="text-2xl font-bold"
          style={{
            fontFamily: "Poppins",
          }}
        >
          Ubah Data Detail Wajah
        </p>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="rounded-2xl border-solid border-gray-300 border shadow-xl bg-white p-6">
          <div className="flex justify-between items-center px-5 w-full">
            <div className="w-2/4">
              <button
                type="submit"
                onClick={goBack}
                disabled={isLoading}
                className="bg-zinc-200 h-11 flex w-auto justify-center items-center rounded-xl hover:bg-gray-100 px-3 py-1.5 text-md font-semibold leading-6 text-black focus-visible:outline shadow-md focus-visible:outline-2 focus-visible:outline-offset-2"
              >
                <ArrowLeftIcon className="h-6 w-auto pr-2" />
                Kembali
              </button>
            </div>
          </div>

          {/* Field Kolom */}
          <div className="flex justify-center items-center py-5 px-5 w-full">
            <div className="w-full flex justify-center items-center">
              <div className="w-full md:w-1/5">
                <label
                  htmlFor="file"
                  className="flex block text-sm font-medium leading-6"
                >
                  Foto Tampak Depan
                  <p className="ml-1 text-red-700">*</p>
                </label>
                <div className="mt-2 w-full aspect-square md:flex-1 border-2 border-gray-300 border-dashed rounded-md flex flex-col items-center justify-center">
                  <div >
                    {loading && (
                      <div>
                        <Skeleton
                          variant="rectangular"
                          width="100%"
                          height={144}
                          className="h-24 md:h-36 rounded-md"
                          animation="wave"
                        />
                      </div>
                    )}

                    {error && !loading && (
                      <div>
                        <img
                          src="/asset/defaultImg.jpeg"
                          alt="Default placeholder"
                          className="w-full h-24 md:h-36 object-cover rounded-md shadow-md opacity-50"
                        />
                        {/* <div className="text-center">Tidak Ada Gambar</div> */}
                      </div>
                    )}

                    {!error && !loading && (
                      <img
                        src={imageUrl}
                        alt="Loaded content"
                     className="w-auto h-auto object-contain flex-shrink-0 mx-auto rounded-sm cursor-not-allowed"
                      />
                    )}
                  </div>
                </div>
                {/* <div className="mt-2 w-full aspect-square md:flex-1 border-2 border-gray-300 border-dashed rounded-md flex flex-col items-center justify-center">
                  {image ? (
                    <img
                      className="w-auto h-auto object-contain flex-shrink-0 mx-auto rounded-sm cursor-not-allowed"
                      src={displayBinaryImage(image)}
                      alt="img"
                    />
                  ) : null}
                </div> */}
              </div>
            </div>
          </div>

          {/* Field Kolom */}
          <div className="flex flex-col md:flex-row justify-between items-center py-5 px-5 w-full">
            <div className="mb-2 md:w-2/4 w-full md:mr-5">
              <label
                htmlFor="register_face_nik"
                className="flex block text-sm font-medium leading-6"
              >
                NIK
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <input
                  id="register_face_nik"
                  name="register_face_nik"
                  type="text"
                  maxLength={16}
                  disabled={isLoading}
                  value={nik}
                  placeholder="Masukkan NIK"
                  onChange={(e) => setNik(e.target.value)}
                  required
                  className="capitalize h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="mb-2 md:w-2/4 w-full">
              <label
                htmlFor="register_face_full_name"
                className="flex block text-sm font-medium leading-6"
              >
                Nama Lengkap
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <input
                  id="register_face_full_name"
                  name="register_face_full_name"
                  type="text"
                  disabled={isLoading}
                  placeholder="Masukkan Nama Lengkap"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                  required
                  className="capitalize h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
          </div>

          {/* Field Kolom */}
          <div className="flex flex-col md:flex-row justify-between items-center py-5 px-5 w-full">
            <div className="mb-2 md:w-2/4 w-full md:mr-5">
              <label
                htmlFor="register_face_place_of_birth"
                className="flex block text-sm font-medium leading-6"
              >
                Tempat Lahir
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <input
                  id="register_face_place_of_birth"
                  name="register_face_place_of_birth"
                  type="text"
                  placeholder="Masukan Tempat Lahir"
                  disabled={isLoading}
                  value={placeOfBirth}
                  onChange={(e) => setPlaceOfBirth(e.target.value)}
                  required
                  className="h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="mb-2 md:w-2/4 w-full">
              <label
                htmlFor="register_face_date_of_birth"
                className="flex block text-sm font-medium leading-6"
              >
                Tanggal Lahir
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <input
                  id="register_face_date_of_birth"
                  name="register_face_date_of_birth"
                  type="date"
                  disabled={isLoading}
                  value={dateOfBirth}
                  placeholder="DD-MM-YYYY"
                  onChange={(e) => setDateOfBirth(e.target.value)}
                  required
                  className="h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
          </div>

          {/* Field Kolom */}
          <div className="flex flex-col md:flex-row justify-between items-center py-5 px-5 w-full">
            <div className="mb-2 md:w-2/4 w-full md:mr-5">
              <label
                htmlFor="register_face_nationality_id"
                className="flex block text-sm font-medium leading-6"
              >
                Kewarganegaraan
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <div className="relative w-full">
                  <select
                    id="register_face_nationality_id"
                    name="register_face_nationality_id"
                    required
                    disabled={isLoading}
                    value={nationalityId}
                    onChange={(e) => setNationalityId(e.target.value)}
                    className={`${isLoading ? "bg-zinc-100" : ""} h-11 block px-4 pr-10 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 appearance-none`}
                  >
                    <option value="" disabled hidden>
                      Pilih Status
                    </option>
                    {Array.isArray(dataNationality) &&
                      dataNationality.map((item) => (
                        <option value={item?.id} key={item?.id}>
                          {item?.nationality_type_name}
                        </option>
                      ))}
                  </select>

                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <svg
                      className="w-5 h-5 text-gray-400"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            <div className="mb-2 md:w-2/4 w-full">
              <label
                htmlFor="register_face_occupation"
                className="flex block text-sm font-medium leading-6"
              >
                Pekerjaan
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <input
                  id="register_face_occupation"
                  name="register_face_occupation"
                  type="text"
                  placeholder="Masukan Pekerjaan"
                  disabled={isLoading}
                  value={occupation}
                  onChange={(e) => setOccupation(e.target.value)}
                  required
                  className="h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
          </div>

          {/* Field Kolom */}
          <div className="flex flex-col md:flex-row justify-between items-center py-5 px-5 w-full">
            <div className="mb-2 md:w-2/4 w-full md:mr-5">
              <label
                htmlFor="register_face_gender_id"
                className="flex block text-sm font-medium leading-6"
              >
                Jenis Kelamin
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <div className="relative w-full">
                  <select
                    id="register_face_gender_id"
                    name="register_face_gender_id"
                    required
                    disabled={isLoading}
                    value={genderId}
                    onChange={(e) => setGenderId(e.target.value)}
                    className={`${isLoading ? "bg-zinc-100" : ""} h-11 block px-4 pr-10 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 appearance-none`}
                  >
                    <option value="" disabled hidden>
                      Pilih Jenis Kelamin
                    </option>
                    {Array.isArray(dataGender) &&
                      dataGender.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.gender_name}
                        </option>
                      ))}
                  </select>
                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <svg
                      className="w-5 h-5 text-gray-400"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            <div className="mb-2 md:w-2/4 w-full">
              <label
                htmlFor="register_face_marital_type"
                className="flex block text-sm font-medium leading-6"
              >
                Status Perkawinan
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <div className="relative w-full">
                  <select
                    id="register_face_marital_type"
                    name="register_face_marital_type"
                    required
                    value={maritalTypeId}
                    disabled={isLoading}
                    onChange={(e) => setMaritalTypeId(e.target.value)}
                    className={`${isLoading ? "bg-zinc-100" : ""} h-11 block px-4 pr-10 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 appearance-none`}
                  >
                    <option value="" disabled hidden>
                      Pilih Status Perkawinan
                    </option>
                    {Array.isArray(dataMaritalType) &&
                      dataMaritalType.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.marital_type_name}
                        </option>
                      ))}
                  </select>
                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <svg
                      className="w-5 h-5 text-gray-400"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Field Kolom */}
          <div className="flex flex-col md:flex-row justify-between items-center py-5 px-5 w-full">
            <div className="mb-4 md:mb-0 md:w-2/4 w-full md:mr-5">
              <label
                htmlFor="register_face_blood_type_id"
                className="flex block text-sm font-medium leading-6"
              >
                Gol Darah
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <div className="relative w-full">
                  <select
                    id="register_face_blood_type_id"
                    name="register_face_blood_type_id"
                    required
                    disabled={isLoading}
                    value={bloodTypeId}
                    onChange={(e) => setBloodTypeId(e.target.value)}
                    className={`${isLoading ? "bg-zinc-100" : ""} h-11 block px-4 pr-10 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 appearance-none`}
                  >
                    <option value="" disabled hidden>
                      Pilih Gol Darah
                    </option>
                    {Array.isArray(dataBloodType) &&
                      dataBloodType.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.blood_type_name}
                        </option>
                      ))}
                  </select>
                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <svg
                      className="w-5 h-5 text-gray-400"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            <div className="md:w-2/4 w-full">
              <label
                htmlFor="register_face_religion_id"
                className="flex block text-sm font-medium leading-6"
              >
                Agama
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <div className="relative w-full">
                  <select
                    id="register_face_religion_id"
                    name="register_face_religion_id"
                    required
                    value={religionId}
                    disabled={isLoading}
                    onChange={(e) => setReligionId(e.target.value)}
                    className={`${isLoading ? "bg-zinc-100" : ""} h-11 block px-4 pr-10 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 appearance-none`}
                  >
                    <option value="" disabled hidden>
                      Pilih Agama
                    </option>
                    {Array.isArray(dataReligion) &&
                      dataReligion.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.religion_type_name}
                        </option>
                      ))}
                  </select>
                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <svg
                      className="w-5 h-5 text-gray-400"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Field Kolom */}
          {/* Alamat Tempat Tinggal */}
          <div className="flex flex-col py-5 px-5 w-full">
            <div className="mb-4 w-full">
              <label
                htmlFor="register_face_address"
                className="flex block text-sm font-medium leading-6"
              >
                Alamat Tempat Tinggal
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <textarea
                  id="register_face_address"
                  name="register_face_address"
                  disabled={isLoading}
                  value={address}
                  placeholder="Masukkan Alamat Tempat Tinggal"
                  onChange={(e) => setAddress(e.target.value)}
                  required
                  className="h-28 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
          </div>

          {/* Status */}
          <div className="flex flex-col md:flex-row justify-between items-center py-5 px-5 w-full">
            <div className="mb-4 md:mb-0 md:w-2/4 w-full md:mr-5">
              <label
                htmlFor="register_face_status_active"
                className="flex  text-sm font-medium leading-6"
              >
                Status
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <div className="relative w-full">
                  <select
                    id="register_face_status_active"
                    name="register_face_status_active"
                    required
                    disabled={isActive}
                    value={isActive}
                    onChange={(e) => setIsActive(e.target.value)}
                    className={`bg-zinc-100 h-11 block px-4 pr-10 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 appearance-none`}
                  >
                    <option value="" disabled hidden>
                      Pilih Status
                    </option>
                    <option value="true">Aktif</option>
                    <option value="false">Tidak Aktif</option>
                  </select>

                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <svg
                      className="w-5 h-5 text-gray-400"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-end mr-5">
            <button
              type="submit"
              className="h-11 flex w-auto justify-center items-center rounded-xl bg-btn-login hover:bg-opacity-50 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
            >
              Simpan
            </button>
          </div>
        </div>
      </form>
      <LoadingModal open={isLoading} />
    </div>
  );
}

export default UpdateRegisterFace;
